import { action } from 'actions/base';
import * as actionTypes from './actionTypes';

export const getCompanyTree = {
    request: () => action(actionTypes.GET_COMPANY_TREE['REQUEST']),
    success: companyTree => action(actionTypes.GET_COMPANY_TREE['SUCCESS'], { companyTree }),
};
